import { useState } from 'react';
import { Paper, Typography, Button, CircularProgress } from '@mui/material';

import AuthKeyView from './AuthKeyView';
import Loader from '../UI/loader/Loader';
import AuthKeyCreatedDialog from './AuthKeyCreatedDialog';
import AuthKeyRegenerateDialog from './AuthKeyRegenerateDialog';

import {
  useGetAuthenticationQuery,
  useGetAuthKeyQuery,
  useDeleteAuthKeyMutation,
  useCreateAuthKeyMutation,
} from '../../services/ADapi';

const AuthKey = () => {
  const [isDialogShow, setDialogState] = useState(false);
  const [isRegenerateDialogShow, setRegenerateDialogState] = useState(false);
  const [key, setKey] = useState('');
  const [isAuthKeyRegenerating, setAuthKeyRegeneratingState] = useState(false);
  const {
    data: { user_id },
  } = useGetAuthenticationQuery();
  const { data: authKey, isLoading, error } = useGetAuthKeyQuery(user_id);
  const [createAuthKey, { isLoading: isAuthKeyCreating }] =
    useCreateAuthKeyMutation();
  const [deleteAuthKey] = useDeleteAuthKeyMutation();

  const createAuthKeyHandler = async () => {
    try {
      const res = await createAuthKey({ user_id }).unwrap();

      setKey(res.auth_key);
      setDialogState(true);
      setRegenerateDialogState(false);
    } catch (error) {
      console.error(error);
    }
  };

  // TODO: refactor this. Combine with createAuthKeyHandler
  const regenerateAuthKeyHandler = async () => {
    setAuthKeyRegeneratingState(true);

    try {
      await deleteAuthKey({ user_id }).unwrap();
      const res = await createAuthKey({ user_id }).unwrap();

      setKey(res.auth_key);
      setAuthKeyRegeneratingState(false);
      setDialogState(true);
      setRegenerateDialogState(false);
    } catch (error) {
      console.error(error);
      setAuthKeyRegeneratingState(false);
    }
  };

  const dialogStateHandler = () => {
    setDialogState((prevState) => !prevState);
  };

  const regenerateDialogStateHandler = () => {
    setRegenerateDialogState((prevState) => !prevState);
  };

  // When we delete an auth key, the next request for a key will return an error, so we check for that error too
  const isAuthKeyCreated = authKey && !error;

  return (
    <Paper>
      <Typography variant="h1" sx={{ pb: '4px' }}>
        AuthKey
      </Typography>
      <Typography variant="body1" sx={{ pb: 3 }}>
        Keys are generated server-side and shown only once.
      </Typography>
      {isLoading ? <Loader /> : null}
      {isAuthKeyCreated ? <AuthKeyView /> : null}
      <Button
        variant="outlined"
        onClick={
          isAuthKeyCreated ? regenerateDialogStateHandler : createAuthKeyHandler
        }
        disabled={isAuthKeyCreating}
      >
        {isAuthKeyCreated ? 'Regenerate key' : 'Generate key'}
        {isAuthKeyCreating ? (
          <CircularProgress size={15} sx={{ ml: 1 }} />
        ) : null}
      </Button>
      {isDialogShow ? (
        <AuthKeyCreatedDialog
          authKey={key}
          isDialogShow={isDialogShow}
          onDialogAction={dialogStateHandler}
        />
      ) : null}
      {isRegenerateDialogShow ? (
        <AuthKeyRegenerateDialog
          isDialogShow={isRegenerateDialogShow}
          onDialogAction={regenerateDialogStateHandler}
          onCreateAction={regenerateAuthKeyHandler}
          isAuthKeyRegenerating={isAuthKeyRegenerating}
        />
      ) : null}
    </Paper>
  );
};

export default AuthKey;
